import { MenuItem } from "@headlessui/react";

export const libraryRequestMenuItemClass = (active) =>
  `flex w-full items-center space-x-2 ${
    active ? "bg-gray-100 text-gray-900" : "text-gray-700"
  } block px-4 py-2 text-sm text-left`;

export default function LibraryRequestMenuItem({ onClick, children, disabled }) {
  return (
    <MenuItem disabled={disabled}>
      {({ active }) => (
        <button
          type="button"
          disabled={disabled}
          onClick={onClick}
          className={libraryRequestMenuItemClass(active)}
        >
          {children}
        </button>
      )}
    </MenuItem>
  );
}
